export default __webpack_public_path__ + "f0d4a0366f6e0c7c3aa74acc726cf9fe.svg";